// extracted by mini-css-extract-plugin
module.exports = {"EditorDropzone":"EditorDropzone__24KoJWGWAqJI"};